<script setup lang="ts">
const t2 = useT2Base({ Optional: 'Pasirinktinai' })

export type Props = {
  label: string
  optional: boolean | None
  disabled: boolean | None
  focus: boolean
  error: string
  before?: string
  after?: string
  labelid: string | undefined
  active: boolean
  width?: '_wcont' | '_w70ch' | 'auto'
}
const props = defineProps<Props>()

const labelid2 = computed(() => props.labelid || generateId())

const css = useCssModule()
const classList = computed(() => {
  const res = [css.t]
  if (props.width) res.push(props.width)
  if (props.optional) res.push('optional')
  if (props.focus) res.push('focus')
  if (props.error) res.push('error')
  if (props.disabled) res.push('disabled')
  if (props.active || props.error) res.push('active')
  return res
})
</script>

<template>
  <div :class="classList">
    <slot name="before">
      <span v-if="before" v-memo="[before]" :class="$style.before">{{ before }}</span>
    </slot>

    <div class="_relative _row _flex">
      <div v-if="label" :class="$style.w">
        <label v-memo="[label]" :for="labelid2" :class="$style.l">{{ label }}</label>
        <span v-if="optional" v-memo="[optional]" class="_italic _pr1 _noline">({{ t2('Optional') }})</span>
        <UiMsg2 :err="error" />
      </div>

      <slot :class-input="$style.inp" />
    </div>

    <slot name="after" :class-after="$style.after">
      <span v-if="after" v-memo="[after]" :class="$style.after">{{ after }}</span>
    </slot>
  </div>
</template>

<style module>
.t {
  composes: global(_relative);
  composes: global(_row);

  composes: global(d_h54);
  composes: global(m_h64);
  composes: global(_br14);

  composes: global(_b5);
  composes: global(_hidden);
  composes: global(_bg0);

  outline: 3px solid transparent;
}

.t:global(.optional) {
  border-style: dashed;
}
.t:global(.error) {
  border-color: red;
  box-shadow: 0 0 0 3px hsla(0, 100%, 50%, 0.2);
}
.t:global(.disabled) {
  cursor: not-allowed;
  background: var(--black-6);
  color: var(--black-4);
  border-color: var(--black-5);
  box-shadow: none;
}
.t:global(.disabled) input,
.t:global(.disabled) .l {
  color: inherit;
}

.t:global(.focus):not(:global(.error)) {
  background: var(--bg);
  box-shadow: 0 0 0 3px var(--blue8);
  border-color: var(--blue7);
}

.w {
  composes: global(_row);
  composes: global(_fs09);
  composes: global(_pt02);
  composes: global(_pl14);
  composes: global(_absolute);

  composes: global(_w100p);
  composes: global(_h16);

  composes: global(_ellipsis);
  composes: global(_break_words);

  top: 0;
  left: 0;

  align-items: flex-start;
  text-align: left;
  word-break: keep-all;
  z-index: 2;
}
.l {
  composes: global(_fw-xl);
  composes: global(_ls-xs);
  composes: global(_fs09);
  composes: global(_c2);

  composes: global(_flexline);
  composes: global(_ws_nowrap);
  composes: global(_mr1);

  text-align: left;
  word-break: keep-all;
}

/*  */
/*  */
/*  */
/*  */

.before {
  composes: global(_row);
  composes: global(_ctrY);

  composes: global(_fs08);
  composes: global(_fw-xl);
  composes: global(_pt2);
  composes: global(_pb02);
  composes: global(_pl04);

  composes: global(_c2);
  cursor: text;
}

.after {
  composes: global(_row);
  composes: global(_ctrY);

  composes: global(_fs08);
  composes: global(_fw-xl);
  composes: global(_ls-xs);

  composes: global(_pr08);
  composes: global(_pl08);

  composes: global(_noselect);

  background: var(--black-6);
  composes: global(_c2);
  cursor: text;
  height: calc(100% - 2px);
  margin: 1px;
  border-radius: 0 12px 12px 0;
}

.inp {
  composes: global(_relative);

  composes: global(d_fs1);
  composes: global(m_fs11);
  composes: global(_fw-l);

  composes: global(_h100p);
  composes: global(_ls-m);

  composes: global(_pt14);
  composes: global(_pb02);
  composes: global(_pl14);

  box-sizing: border-box;
  background-color: transparent;
  border: 0 solid transparent;
  outline: none;
  transition: padding 100ms ease-in;
  z-index: 1;
  word-spacing: 1.2px;
  color: var(--blue2);
  min-width: 80px;
  flex-grow: 1;
}
.inp::placeholder,
.inp:placeholder-shown {
  color: var(--black-4);
  opacity: 0.7;
}
.inp::selection {
  color: var(--bg);
  background: #0069ff;
}
</style>
